export default function DropdownText(props: any) {
  return (
    <div className="dropdown-text">
      {props.children}
    </div>
  )
}
